import { Directive,ElementRef } from '@angular/core';

@Directive({
    selector: '[appPhone]',
    standalone: false
})
export class PhoneDirective {

  constructor(elemnt:ElementRef) { 
    elemnt.nativeElement.style.backgroundColor = 'yellow';
  }

}
